import { z } from 'zod';

const MaskedLocationSchema = z.object({
  city: z.string().nullable().optional(),
  state: z.string().nullable().optional(),
  zip: z.string().nullable().optional(),
});

const MaskedStopSchema = z.object({
  stopType: z.enum(['PICKUP', 'DELIVERY']),
  location: MaskedLocationSchema,
});

export const MaskedMovementDataSchema = z.object({
  stops: z.array(MaskedStopSchema).nullable().optional(),
  weight: z
    .object({
      value: z.number(),
      unit: z.enum(['LBS', 'KGS']),
    })
    .nullable()
    .optional(),
});

export type MaskedMovementData = z.infer<typeof MaskedMovementDataSchema>;
export type MaskedLocation = z.infer<typeof MaskedLocationSchema>;
export type MaskedStop = z.infer<typeof MaskedStopSchema>;
